import { Card } from '../../components/ui/card';
import { PhoneCall, PhoneIncoming, Users, Snowflake, PhoneOff, ListChecks } from 'lucide-react';

const Kpi = ({ k, label, value, sub, icon: Icon, tint }) => (
  <Card className="p-4" data-testid={`cbt-kpi-${k}`}>
    <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-2 ${tint}`}><Icon className="w-4 h-4" /></div>
    <div className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">{label}</div>
    <div className="text-xl font-bold mt-0.5 text-slate-900">{value}</div>
    {sub && <div className="text-[11px] text-slate-500">{sub}</div>}
  </Card>
);

export const CbtScorecard = ({ data }) => {
  const t = data.totals;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3" data-testid="cbt-kpis">
        <Kpi k="leads" label="In Call Back now" value={t.leads} icon={ListChecks} tint="bg-slate-100 text-slate-700" />
        <Kpi k="calls" label="Calls in period" value={t.calls} sub={`${data.from} → ${data.to}`} icon={PhoneCall} tint="bg-blue-50 text-blue-600" />
        <Kpi k="leads-called" label="Leads called" value={t.leads_called} icon={Users} tint="bg-indigo-50 text-indigo-600" />
        <Kpi k="connected" label="Connected" value={t.connected} sub={t.calls ? `${Math.round(t.connected / t.calls * 100)}% of calls` : ''} icon={PhoneIncoming} tint="bg-emerald-50 text-emerald-600" />
        <Kpi k="cold" label="Going cold" value={t.cold} sub={`not called ${data.settings.cold_days}+ days`} icon={Snowflake} tint="bg-sky-50 text-sky-600" />
        <Kpi k="never" label="Never called" value={t.never_called} sub={`in last ${data.call_window_days} days`} icon={PhoneOff} tint="bg-rose-50 text-rose-600" />
      </div>
      <Card className="p-4" data-testid="cbt-scorecard-table">
        <h3 className="text-sm font-bold text-slate-900">User scorecard</h3>
        <p className="text-[11px] text-slate-500 mb-3">Calls = calls this user made on Call Back leads in the period. Owned / cold / never called = Call Back leads this user owns right now.</p>
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="text-[10px] uppercase tracking-wider text-slate-400"><tr>
              <th className="text-left py-1">CRM user</th><th className="text-right">Calls</th><th className="text-right">Leads called</th><th className="text-right">Connected</th>
              <th className="text-right">Connect %</th><th className="text-right">Talk min</th><th className="text-right pl-4 border-l border-slate-100">Leads owned</th>
              <th className="text-right">Cold</th><th className="text-right">Never called</th></tr></thead>
            <tbody>
              {data.people.length === 0 && <tr><td colSpan={9} className="text-center text-slate-400 py-8">No data yet — click Update from CRM.</td></tr>}
              {data.people.map(p => (
                <tr key={p.user} className="border-t border-slate-100" data-testid={`cbt-user-${p.user.replace(/[^a-zA-Z0-9]/g, '-')}`}>
                  <td className="py-2 font-medium text-slate-800">{p.user}</td>
                  <td className="text-right font-bold">{p.calls}</td><td className="text-right">{p.leads_called}</td>
                  <td className="text-right text-emerald-700">{p.connected}</td><td className="text-right">{p.connect_pct}%</td><td className="text-right">{p.talk_min}</td>
                  <td className="text-right pl-4 border-l border-slate-100">{p.owned}</td>
                  <td className={`text-right ${p.cold ? 'text-sky-700 font-semibold' : 'text-slate-300'}`}>{p.cold}</td>
                  <td className={`text-right ${p.never_called ? 'text-rose-600 font-semibold' : 'text-slate-300'}`}>{p.never_called}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};
